import { Pipe, PipeTransform } from "@angular/core";

export interface TimeCreatedOwner {
    readonly timeCreate?: Date;
}

@Pipe({ name: 'sorting' })
export class SortingPipe implements PipeTransform {
    transform<T extends TimeCreatedOwner>(collection: T[] | undefined, index: number = 0, by: string = 'timeCreate'): T[] {
        if (collection == null) return [];
        return collection.sort((x: any, y: any) => {
            if (by in x && by in y) {
                if (by === 'timeCreate') {
                    const a = new Date(x[by]);
                    const b = new Date(y[by]);
                    return a.getTime() - b.getTime();
                } else {
                    return x[by] - y[by];
                }
            }
            return 0;
    });
    }
}
